module.exports = __webpack_public_path__ + "static/share-screen-b2230f775a761df63e3e7cdab05286d6.png";